<template>
    <b-card
      :border-variant="this.variant"
      align="center"
      :footer="this.footerText"
      footer-tag="footer"
      :footer-bg-variant="this.variant"
      :footer-border-variant="this.variant"
      style="width: 23rem;"
      @click="this.$emit(cardClicked, this.tpr.externalReference)"
    >
      <b-card-text>
        <b-iconstack font-scale="5" style="position:absolute; top:5px; right:5px;">
          <b-icon stacked icon="circle-fill" scale="1.25" :variant="this.variant"></b-icon>
          <b-icon stacked :icon="this.icon" scale="1"></b-icon>
        </b-iconstack>
        {{tpr.externalReference}}
        <p>
          <strong>
            <div class="cardHeader">{{tpr.treatment.hospitalName}}</div>
          </strong>
        </p>
        <p>
          <strong>Surgeon Name:</strong>
          {{ surgeonName(tpr.treatment.surgeonName) }}
        </p>
        <p>
          <strong>Sales Rep:</strong>
          {{ salesRep(tpr.primaryContact) }}
        </p>
        <p>
          <strong>Covering Rep:</strong>
          {{ coveringReps(tpr.otherContacts) }}
        </p>
        <p>
          <strong>Patient ID:</strong>
        </p>
        <p>
          <strong>Procedure:</strong>
          {{ tpr.treatment.application.applicationType }}
        </p>
        <p>
          <strong>Surgery Date:</strong>
          {{ surgeryDate(tpr.treatment.surgeryDate) }}
        </p>
      </b-card-text>
    </b-card>
</template>

<script>
import moment from 'moment'
export default {
  props: ["tpr"],
  methods: {
    surgeryDate(date) {
      return moment(date).format("M/D/YYYY, h:mm A");
    },
    surgeonName(surgeon) {
      return (
        surgeon.firstName +
        " " +
        surgeon.lastName
      );
    },
    salesRep(rep) {
      return (
        rep.firstName +
        " " +
        rep.lastName
      );
    },
    coveringReps(coveringReps) {
      var reps = "";
      coveringReps.forEach(rep => {
        reps += rep.firstName;
        reps += " ";
        reps += rep.lastName;
        reps += ", ";
      });
      return reps;
    }
  },
  computed: {
    icon() {
      switch (this.tpr.metadata.commentedRequestState.requestState) {
        case 'Created':
          return 'plus'
        case 'Submitted':
          return 'reply'
        case 'TreatmentPlanAvailable':
          return 'check'
        case 'Cancelled':
          return 'x'
        default:
          return 'question'
      }
    },
    footerText() {
      switch (this.tpr.metadata.commentedRequestState.requestState) {
        case 'Created':
          return 'new'
        case 'Submitted':
          return 'requested'
        case 'TreatmentPlanAvailable':
          return 'completed'
        case 'Cancelled':
          return 'cancelled'
        default:
          return 'unknown'
      }
    },
    variant() {
      switch (this.tpr.metadata.commentedRequestState.requestState) {
        case 'Created':
          return 'danger'
        case 'Submitted':
          return 'primary'
        case 'TreatmentPlanAvailable':
          return 'success'
        case 'Cancelled':
          return 'secondary'
        default:
          return 'light'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card-text {
  text-align: left;
  font-size: x-small;
  height: 8rem;
}

.card-footer {
  text-align: left;
  font-size: small;
  font-weight: bold;
}

.cardHeader {
  font-size: medium !important;
}
p {
  margin-bottom: 0 !important;
}
</style>